import type { ApiTableCommandFactory } from 'components/ApiTable/model/ApiTableModel';
import { closeAdvancedFilter } from 'components/ApiTable/model/commands/closeAdvancedFilter';

export const openAddIntentRuleForm: ApiTableCommandFactory =
  (cmdContext, dispatch) => () => {
    dispatch(closeAdvancedFilter);
    cmdContext.updateState((draft) => {
      draft.intentVerifications.addRule = true;
    });
  };
